/** ----------------------------------------
    IBAN
---------------------------------------- */

import { Validator } from 'vee-validate';

Validator.extend('terms', {
    validate (value) {
        return value === true;
    },
    getMessage (field) {
        return `Agreeing with terms is required`;
    }
});